import React from "react";

import { Datagrid } from "jazasoft";

// perfect scrollbar
import "react-perfect-scrollbar/dist/css/styles.css";
import PerfectScrollbar from "react-perfect-scrollbar";

const ScrollableDatagrid = props => {
  return (
    <PerfectScrollbar>
      <Datagrid {...props} />
    </PerfectScrollbar>
  );
};

export default ScrollableDatagrid;
